<mat-toolbar class="mc-toolbar-large" [ngClass]="{ 'mc-code-editor-status-bar-visible': !!text }" [color]="color">
  <ng-container *ngIf="text">
    <mat-icon fontSet="project-titan" fontIcon="icon-alert" class="mc-centered-text-icon"></mat-icon>
    {{ text }}
  </ng-container>
</mat-toolbar>
